import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioConsultaDiariasPassagens: ['exercicio'],
    setAdministracaoConsultaDiariasPassagens: ['administracao'],
    setNomeConsultaDiariasPassagens: ['nome'],
    setCpfConsultaDiariasPassagens: ['cpf'],
    setDataEmpenhoInicialConsultaDiariasPassagens: ['dataEmpenhoInicial'],
    setDataEmpenhoFinalConsultaDiariasPassagens: ['dataEmpenhoFinal'],
    setCargoConsultaDiariasPassagens: ['cargo'],
    limpaFiltroConsultaDiariasPassagens: [],
    receberFiltroConsultaDiariasPassagens: ['filtroRecebido'],
    setStatusConsultaDiariasPassagens: ['status'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    administracao: [],
    nome: '',
    cpf: '',
    dataEmpenhoInicial: '',
    dataEmpenhoFinal: '',
    cargo: [],
    status: { label: '', value: '' },
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setNome = (state = INITIAL_STATE, action) => {
    return { ...state, nome: action.nome }
}

const setCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: action.cpf }
}

const setDataEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoInicial: action.dataEmpenhoInicial }
}

const setDataEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoFinal: action.dataEmpenhoFinal }
}

const setCargo = (state = INITIAL_STATE, action) => {
    return { ...state, cargo: action.cargo }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_DIARIAS_PASSAGENS]: setExercicio,
    [Types.SET_ADMINISTRACAO_CONSULTA_DIARIAS_PASSAGENS]: setAdministracao,
    [Types.SET_NOME_CONSULTA_DIARIAS_PASSAGENS]: setNome,
    [Types.SET_CPF_CONSULTA_DIARIAS_PASSAGENS]: setCpf,
    [Types.SET_DATA_EMPENHO_INICIAL_CONSULTA_DIARIAS_PASSAGENS]: setDataEmpenhoInicial,
    [Types.SET_DATA_EMPENHO_FINAL_CONSULTA_DIARIAS_PASSAGENS]: setDataEmpenhoFinal,
    [Types.SET_CARGO_CONSULTA_DIARIAS_PASSAGENS]: setCargo,
    [Types.LIMPA_FILTRO_CONSULTA_DIARIAS_PASSAGENS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_DIARIAS_PASSAGENS]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_DIARIAS_PASSAGENS]: setStatus,
})
